import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["menu", "trigger"]
  }

  // "open" is skipped for the Classes API: it's the app's shared open/closed toggle idiom
  // (bootstrap dropdowns, teams-menu.scss, dashboard.scss, gives/design.scss all reuse the bare
  // `.open` selector), not a name this controller owns. "mobile-menu-open" is unique to this
  // controller (lasso/v2/pages/gives/base.scss:96) so it gets the Classes API treatment.
  static get classes() {
    return ["bodyOpen"]
  }

  get bodyOpenClassName() {
    return this.hasBodyOpenClass ? this.bodyOpenClass : "mobile-menu-open"
  }

  disconnect() {
    this.restoreProgressBarDelay()
  }

  // Closes the drawer and shows Turbo's progress bar right away, so a tap on a step link gets
  // immediate feedback while the next page loads.
  navigate(event) {
    const link = event.target.closest("a[href]")
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) {
      return
    }

    const drive = window.Turbo?.config?.drive
    if (drive && this.previousProgressBarDelay === undefined) {
      this.previousProgressBarDelay = drive.progressBarDelay
      drive.progressBarDelay = 0
    }

    if (this.menuTarget.classList.contains("open")) {
      this.toggle()
    } 
  }

  restoreProgressBarDelay() {
    if (this.previousProgressBarDelay === undefined) {
      return
    }

    window.Turbo.config.drive.progressBarDelay = this.previousProgressBarDelay
    this.previousProgressBarDelay = undefined
  }

  toggle() {
    if (this.menuTarget.classList.contains("open")) {
      this.triggerTarget.focus()
    }
    this.menuTarget.classList.toggle("open")
    this.updateAria()
    this.updateBodyScroll()
  }

  updateAria() {
    const isOpen = this.menuTarget.classList.contains("open")
    this.menuTarget.setAttribute("aria-hidden", !isOpen)
    this.triggerTarget.setAttribute("aria-expanded", isOpen)
  }

  updateBodyScroll() {
    const isOpen = this.menuTarget.classList.contains("open")
    document.body.classList.toggle(this.bodyOpenClassName, isOpen)
  }
}
